import axios from "axios";
import { Blog } from "../interfaces/blog.interface";

class PostsApi {

  getBlogs(): Promise<Blog[]> {
    const apiUrl = "/api/v1/posts";

    return axios.get(apiUrl)
    .then(response => {
      const blogs = response.data.data.map(postData => {
        const post:Blog = {
          id: postData.attributes.id,
          title: postData.attributes.title,
          thumbnail: postData.attributes.thumbnail,
          content: postData.attributes.body,
          // author: postData.attributes.author,
          // createdOn: postData.attributes.created_on,
        }
        return post;
      })
      return Promise.resolve(blogs);
    });
  }


  getBlog(blogId:number): Promise<Blog> {
    const apiUrl = `/api/v1/posts/${blogId}`;

    return axios.get(apiUrl)
    .then(response => {
      const postData = response.data.data.attributes;
      const post:Blog = {
        id: response.data.data.id,
        title: postData.title,
        thumbnail: postData.thumbnail,
        content: postData.body,
        // author: postData.author,
        // createdOn: postData.created_on,
      }
      return Promise.resolve(post);
    });
  }

}

export default PostsApi;